"use strict";

var countWords = require("../stringProcessing/countWords");
var sanitizeString = require("../stringProcessing/sanitizeString");
/**
 * Determines the length in words of a the keyphrase, the keyword is a keyphrase if it is more than one word.
 *
 * @param {Paper} paper The paper to research
 * @returns {number} The length of the keyphrase
 */
function keyphraseLengthResearch(paper) {
  var keyphrase = sanitizeString(paper.getKeyword());
  return countWords(keyphrase);
}
module.exports = keyphraseLengthResearch;
//# sourceMappingURL=keyphraseLength.js.map
//# sourceMappingURL=keyphraseLength.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/keyphraseLength.js
// module id = 395
// module chunks = 0